import { useNavigate } from 'react-router-dom';

import { Layout } from '@components/Layout';
import { SaveForLater as SaveForLaterUi } from '@features/SaveForLater';
import useResetSaveForLaterRemoteForm from '@features/SaveForLater/SaveForm/hooks/useResetSaveForLaterRemoteForm';
import { withProfiler } from '@services/sentry/withProfiler';

const SaveForLaterUnwrapped = () => {
  const navigate = useNavigate();
  const reset = useResetSaveForLaterRemoteForm();

  const handleOnBack = () => {
    // or else the remote form will be populated with the previous values if the user goes back to the form
    reset();

    navigate(-1);
  };

  return (
    <Layout title="Share your quote" onBack={handleOnBack}>
      <SaveForLaterUi />
    </Layout>
  );
};

const SaveForLater = withProfiler(SaveForLaterUnwrapped);

export { SaveForLater };
